import { atom } from 'jotai'

import * as s1 from './state.profile'

// read-only derived atom
export const isUserAtom = atom(
	// getter
	(get) => {
		const profile = get(s1.profileAtom)
		const profileRole = profile?.role
		return profileRole?.code === 'user'
	}
)
